import script from "./sidebar.vue?vue&type=script&setup=true&lang=js"
export * from "./sidebar.vue?vue&type=script&setup=true&lang=js"

import "./sidebar.vue?vue&type=style&index=0&id=e254b344&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e254b344"]])

export default __exports__